import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { latLng, tileLayer } from "leaflet";
import { Router } from "@angular/router";
import { DataService } from "src/app/shared/Services/data.service";
import { HttpClient } from "@angular/common/http";
import { Subject } from "rxjs";
import { ShareService } from "src/app/shared/Services/shared.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { takeUntil } from "rxjs/operators";
import * as moment from "moment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GetCurrentShift } from "src/app/shared/Services/getCurrentShift";
export interface ChartType {
  series?: any;
  plotOptions?: any;
  stroke?: any;
  dataLabels?: any;
  chart?: any;
  legend?: any;
  colors?: any;
  labels?: any;
}

@Component({
  selector: "app-admin_dashboard",
  templateUrl: "./admin_dashboard.component.html",
  styleUrls: ["./admin_dashboard.component.scss"],
})
export class AdminDashboardComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  private abortController: AbortController;
  sparklineEarning: any = {};
  term: any;
  custId:any;
  apiInterval: any;
  selectedCustomerId:any;
  customerList = [];
  machine_List: any[] = [];
  oeeOption: any;
  liveBool: boolean = false;
  time: any = [];
  todayData: any = [];
  showload: boolean = false;
  yesterdayData: any = [];
  queryDate: any;
  chartData: any;
  todayKey: any;
  yesterdayKey: any;
  todaySummary: any;
  user: any;
  cancelRequest: boolean = false;
  timeZone: any;
  shiftInfio: any;
  role: any;
  current: any;
  avail: any;
  m_effic: any;
  parts: any;
  showMe: boolean = false;
  tempData: any;
  deviceResults: any;
  performanceOption: any;
  machine_Lists: any;
  deviceList: any = [];
  customerId:any;
  breadCrumbItems: Array<{}>;
  chatSubmit: boolean;
  formData: FormGroup;
  currentShiftData: any;
  filteredData = [];
  departmentData: any = [];
  selectedDepartment: "";
  private cancelPreviousRequests$ = new Subject<void>();

  constructor(
    private cdRef: ChangeDetectorRef,
    public formBuilder: FormBuilder,
    private dataservice: DataService,
    private http: HttpClient,
    private router: Router,
    private sharedService: ShareService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private currentshifts: GetCurrentShift,
    private modalService: NgbModal
  ) {
    this.abortController = new AbortController();
    this.user = JSON.parse(sessionStorage.getItem("currentUser"));
    this.role = this.user["user"]["role"];
    this.custId = this.user["user"]["custId"];
  }

  ngOnInit(): void {
    this.showload = true;
    this.spinner.show();
    this.user = JSON.parse(sessionStorage.getItem("currentUser"));

    this.timeZone = moment.tz.guess();
    this.breadCrumbItems = [];
    this.formData = this.formBuilder.group({
      message: ["", [Validators.required]],
    });
    this.machine_Lists = this.sharedService.getDeviceList()
      ? this.sharedService.getDeviceList()
      : [];
    this.machine_List = this.machine_Lists["machineList"];
    this.getUser();
    if (this.apiInterval) clearTimeout(this.apiInterval);
    this.apiInterval = setTimeout(() => {
      this.toastr.info("If you want live data, click the Refresh button!");
    }, 180000);
  }

  getUser() {
    this.dataservice.get("api/user").subscribe((res: any) => {
      let response = res;
      var custList = response.filter((val) => {
        return val.name !== "SUPERADMIN";
      });
      this.validate_customer(custList);
    });
  }

  validate_customer(data) {
    const filteredData = data.filter((item) => {
      return (
        item.status &&
        Array.isArray(item.status.deviceDetails) &&
        item.status.deviceDetails.length > 0
      );
    });
    this.customerList = filteredData.map((item) => {
      return {
        custName: item.status.customerName,
        custId: item.status.custId,
        deviceList: item.status.deviceDetails,
        timeZone: item.timeZone,
      };
    });
    var custId = sessionStorage.getItem("Selected_CustomerID");
    this.timeZone = sessionStorage.getItem("Selected_CustomerTimeZone");
    if (custId === null) {
      this.customerId = this.customerList[0]["custId"];
      this.getDepartment(this.customerId);
      this.custDevices(this.customerId);

      this.selectedCustomerId = this.customerList[0];
      sessionStorage.setItem(
        "Selected_CustomerName",
        this.selectedCustomerId.custName
      );
      sessionStorage.setItem(
        "Selected_CustomerID",
        this.selectedCustomerId.custId
      );
      sessionStorage.setItem(
        "Selected_CustomerTimeZone",
        this.selectedCustomerId.timeZone
      );
    } else {
      this.customerId = custId;
      this.getDepartment(this.customerId);
      this.custDevices(this.customerId);
      let selected = this.customerList.filter((val) => {
        return val.custId == custId;
      });
      this.selectedCustomerId = selected[0];
    }
  }

  getDepartment(custId) {
    this.departmentData = [];
    this.dataservice
      .get(`department?custId=${custId}`)
      .subscribe((res: any) => {
        if (res) {
          this.departmentData = res["data"];
          this.selectedDepartment = this.departmentData[0]["departmentName"];

          var shift: any = {
            shift: this.departmentData[0]["shiftData"],
          };
          sessionStorage.setItem("shiftInfio", JSON.stringify(shift));
          this.currentShiftData = this.currentshifts.getCurrentShift(
            this.departmentData[0]["shiftData"],
            this.timeZone
          );
          this.queryDate =
            moment
              .tz(
                this.currentShiftData["currentDate"],
                "YYYY-MM-DD HH:mm:ss",
                this.timeZone
              )
              .format("YYYY-MM-DD") ||
            moment.tz(this.timeZone).format("YYYY-MM-DD");
          this.getAPQOChartData(custId);
          this.custDevices(custId);
          this.filterByCustId(custId);
        }
      });
  }

  getAPQOChartData(custId) {
    this.dataservice
      .get(
        `department/depthourlyoee?custId=${custId}&date=${this.queryDate}&department=${this.selectedDepartment}&shiftName=${this.currentShiftData["usershiftId"]}`
      )
      .subscribe(
        (res) => {
          if (res) {
            this.showload = false;
            this.spinner.hide();
            this.chartData = res;
            this.todayData = this.chartData["today"] || [];
            this.yesterdayData = this.chartData["yesterday"] || [];
            this.todaySummary = this.chartData["todaySummary"];
            this.time = this.chartData["time"] || [];
            this.performanceChart();

            this.oeeChart();
          } else {
          }
          this.showload = false;
          this.spinner.hide();
        },
        (error: any) => {
          this.showload = false;
          this.spinner.hide();
          this.toastr.error(error);
        }
      );
  }

  custDevices(id) {
    this.deviceList = [];
    this.dataservice.get(`api/device?custId=${id}`).subscribe((res) => {
      this.deviceList = res;
    });
  }

  filterByCustId(custId: string): void {
    this.filteredData = this.customerList.filter(
      (customer) => customer.custId === custId
    );
    this.getData_new();
  }

  async getData_new(): Promise<void> {
    this.machine_List = [];
    this.showMe = false;

    this.cancelPreviousRequests$.next();

    for (const customer of this.filteredData) {
      for (const device of customer.deviceList) {
        if (this.cancelRequest) {
          this.cancelPreviousRequests$.next();
          return;
        }

        try {
          if (this.selectedDepartment == device.departmentName) {
            const data = {
              custID: customer.custId,
              deviceID: device.deviceId,
            };
            this.showMe = true;

           this.dataservice
            .machineApi(
              `${ this.liveBool ? "liveMachine" : "machineCard"}`,
                data
              )
              .pipe(takeUntil(this.cancelPreviousRequests$))
              .subscribe({
                next: (response: any) => {
                  if (!Array.isArray(this.machine_List)) {
                    this.machine_List = [];
                  }

                  const index = this.machine_List.findIndex(
                    (item) => item.device_id === response.device_id
                  );

                  if (index !== -1) {
                    this.machine_List[index] = response;
                  } else {
                    this.machine_List.push(response);
                  }

                  this.sharedService.setShiftData({
                    shift: response["Shift_List"],
                  });
                  this.sharedService.setDeviceList({
                    machineList: this.machine_List,
                  });
                },
                error: (error) => {
                  console.error("Error fetching device data:", error);
                },
              });
          }
        } catch (error) {
          console.error("Error preparing device data:", error);
        }
      }
    }
  }

  performanceChart() {
    this.performanceOption = {
      legend: {
        top: -5,
        icon: "line",
      },
      tooltip: {
        trigger: "axis",
        appendToBody: true,
        backgroundColor: "#fff",
        borderColor: "rgba(82, 78, 78, 0.8)",
        borderWidth: 1,
        textStyle: {
          color: "black",
          fontSize: 12,
          fontWeight: "bold",
        },
        extraCssText: "border-radius: 8px; padding: 8px;",
        formatter: (params: any) => {
          let tooltipContent = `<div style="text-align: left;">`;
          tooltipContent += `<div style="font-size: 14px; font-weight: bold; margin-bottom: 5px;">🕒 Time: ${params[0]?.axisValue}</div>`;

          let seriesA = params.find(
            (item: any) => item.seriesName === this.yesterdayKey
          );
          let seriesB = params.find(
            (item: any) => item.seriesName === this.todayKey
          );

          params.forEach((item: any) => {
            tooltipContent += `
              <div style="display: flex; align-items: center; margin-bottom: 3px;">
                <div style="width: 10px; height: 10px; background: ${
                  item.color
                }; border-radius: 50%; margin-right: 5px;"></div>
                <div style="font-size: 12px;">
                  <b>${item.seriesName}:</b> ${
              Number(item.value)?.toFixed(2) || "0"
            }%
                </div>
              </div>`;
          });

          if (seriesA && seriesB) {
            let diff = seriesB.value - seriesA.value;
            let diffColor = diff > 0 ? "green" : "red";
            let diffIcon = diff > 0 ? "▲" : "▼";

            tooltipContent += `
              <div style="font-size: 12px; font-weight: bold; color: ${diffColor}; margin-top: 5px; text-align: center;">
                ${diffIcon} ${Math.abs(diff)}%
              </div>`;
          }

          tooltipContent += `</div>`;
          return tooltipContent;
        },
      },

      xAxis: {
        name: "(hrs)",
        type: "category",
        data: this.time,
        axisTick: { show: false },
        axisLabel: {
          rotate: 0,
          fontSize: 9,
          formatter: function (value) {
            return value.split(" - ")[1];
          },
        },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 100,
        splitNumber: 2,
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          formatter: (value: number) => value + "%",
        },
      },
      grid: {
        left: 50,
        right: "7%",
        top: 10,
        bottom: 100,
      },
      series: [
        {
          name: "Today",
          data: this.todayData?.map((elm: any) => elm.performance.toFixed(2)),
          type: "line",
          symbol: "none",
          smooth: false,
          lineStyle: {
            type: "solid",
          },
        },
        {
          name: "Yesterday",
          data: this.yesterdayData?.map((elm: any) =>
            elm.performance.toFixed(2)
          ),
          type: "line",
          symbol: "none",
          smooth: false,
          lineStyle: {
            type: "dashed",
          },
        },
      ],
    };
  }

  oeeChart() {
    this.oeeOption = {
      legend: {
        top: -5,
        icon: "line",
      },
      tooltip: {
        trigger: "axis",
        appendToBody: true,
        backgroundColor: "#fff",
        borderColor: "rgba(82, 78, 78, 0.8)",
        borderWidth: 1,
        textStyle: {
          color: "black",
          fontSize: 12,
          fontWeight: "bold",
        },
        extraCssText: "border-radius: 8px; padding: 8px;",
        formatter: (params: any) => {
          let tooltipContent = `<div style="text-align: left;">`;
          tooltipContent += `<div style="font-size: 14px; font-weight: bold; margin-bottom: 5px;">🕒 Time: ${params[0]?.axisValue}</div>`;

          let seriesA = params.find(
            (item: any) => item.seriesName === this.yesterdayKey
          );
          let seriesB = params.find(
            (item: any) => item.seriesName === this.todayKey
          );

          params.forEach((item: any) => {
            tooltipContent += `
              <div style="display: flex; align-items: center; margin-bottom: 3px;">
                <div style="width: 10px; height: 10px; background: ${
                  item.color
                }; border-radius: 50%; margin-right: 5px;"></div>
                <div style="font-size: 12px;">
                  <b>${item.seriesName}:</b> ${
              Number(item.value)?.toFixed(2) || "0"
            }%
                </div>
              </div>`;
          });

          if (seriesA && seriesB) {
            let diff = seriesB.value - seriesA.value;
            let diffColor = diff > 0 ? "green" : "red";
            let diffIcon = diff > 0 ? "▲" : "▼";

            tooltipContent += `
              <div style="font-size: 12px; font-weight: bold; color: ${diffColor}; margin-top: 5px; text-align: center;">
                ${diffIcon} ${Math.abs(diff)}%
              </div>`;
          }

          tooltipContent += `</div>`;
          return tooltipContent;
        },
      },

      xAxis: {
        name: "(hrs)",
        type: "category",
        data: this.time,
        axisTick: { show: false },
        axisLabel: {
          rotate: 0,
          fontSize: 9,
          formatter: function (value) {
            return value.split(" - ")[1];
          },
        },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 100,
        splitNumber: 2,
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          formatter: (value: number) => value + "%",
        },
      },
      grid: {
        left: 50,
        right: "7%",
        top: 10,
        bottom: 100,
      },
      series: [
        {
          name: "Today",
          data: this.todayData?.map((elm: any) => elm.oee.toFixed(2)),
          type: "line",
          symbol: "none",
          smooth: false,
          lineStyle: {
            type: "solid",
          },
        },
        {
          name: "Yesterday",
          data: this.yesterdayData?.map((elm: any) => elm.oee.toFixed(2)),
          type: "line",
          symbol: "none",
          smooth: false,
          lineStyle: {
            type: "dashed",
          },
        },
      ],
    };
  }

  changeDepartment(e) {
    this.cancelPreviousRequests$.next();
    this.selectedDepartment = e.target.value;
    const data = this.departmentData.find(
      (val) => val.departmentName === this.selectedDepartment
    );

    if (data && data.shiftData) {
      var shift: any = {
        shift: data.shiftData,
      };
      sessionStorage.setItem("shiftInfio", JSON.stringify(shift));
      this.currentShiftData = this.currentshifts.getCurrentShift(
        data["shiftData"],
        this.timeZone
      );
    }

    this.refresh("ts");
  }

  getPartCount(param) {
    if (param.hasOwnProperty("partcountType")) {
      if (
        param["partcountType"] === "digital" &&
        param.hasOwnProperty("part_count")
      ) {
        if (param["part_count"] === null) {
          return "0";
        } else {
          return param["part_count"];
        }
      } else if (
        param["partcountType"] === "AI" &&
        param.hasOwnProperty("Ai_partcount")
      ) {
        if (param["Ai_partcount"] === null) {
          return "0";
        } else {
          return param["Ai_partcount"];
        }
      } else {
        return "0";
      }
    } else {
      return "0";
    }
  }

  get aiPartCount() {
    let total = 0;

    // if (this.liveBool) {
      if (this.machine_List.length) {
        total =
          this.machine_List?.reduce(
            (sum, item) => sum + (item.Ai_partcount || 0),
            0
          ) || 0;
      } else {
        total = 0;
      }
    // } else {
    //   total = this.todaySummary?.Ai_partcount || 0;
    // }

    return total.toFixed(0);
  }

  get totalEnergy() {
    let total = 0;

    // if (this.liveBool) {
      if (this.machine_List.length) {
        total =
          this.machine_List?.reduce(
            (sum, item) => sum + (item.total_energy || 0),
            0
          ) || 0;
      }
    // } else {
    //   total = this.todaySummary?.total_energy || 0;
    // }

    return total.toFixed(2);
  }

  get energyCost() {
    let total = 0;

    // if (this.liveBool) {
      if (this.machine_List.length) {
        total =
          this.machine_List?.reduce(
            (sum, item) => sum + (item.energy_cost || 0),
            0
          ) || 0;
      }
    // } else {
    //   total = this.todaySummary?.energyCost || 0;
    // }

    return total.toFixed(2);
  }

  get revenueLoss() {
    let total = 0;

    // if (this.liveBool) {
      if (this.machine_List.length) {
        total =
          this.machine_List?.reduce(
            (sum, item) => sum + (item.revenueLoss || 0),
            0
          ) || 0;
      }
    // } else {
    //   total = this.todaySummary?.RevenueLoss || 0;
    // }

    return total.toFixed(2);
  }

  get totaloee() {
    let total = 0;

    // if (this.liveBool) {
      if (this.machine_List.length) {
        const sum = this.machine_List.reduce(
          (acc, item) => acc + (item.oee || 0),
          0
        );
        total = sum / this.machine_List.length;
      }
    // } else {
    //   total = this.todaySummary?.avg_oee || 0;
    // }

    return total.toFixed(2);
  }

  get totalperf() {
    let total = 0;

    // if (this.liveBool) {
      if (this.machine_List.length) {
        const sum = this.machine_List.reduce(
          (acc, item) => acc + (item.performance || 0),
          0
        );
        total = sum / this.machine_List.length;
      }
    // } else {
    //   total = this.todaySummary?.avg_perf || 0;
    // }

    return total.toFixed(2);
  }

  trackByDevice(index: number, item: any): string {
    return item.deviceId;
  }

  refresh(val: any) {
    this.showload = true;
    this.spinner.show();
    this.todayData = [];
    this.yesterdayData = [];
    if (val == "ts") {
      this.liveBool = false;
    } else {
      this.liveBool = true;
    }

    this.machine_List = [];
    var custId = sessionStorage.getItem("Selected_CustomerID");
    this.timeZone = sessionStorage.getItem("Selected_CustomerTimeZone");
    if (custId === null) {
      this.customerId = this.customerList[0]["custId"];
      this.selectedCustomerId = this.customerId;
      this.filterByCustId(this.customerId);
      this.getAPQOChartData(this.customerId);
    } else {
      this.selectedCustomerId = custId;
      this.getAPQOChartData(custId);
      this.filterByCustId(this.selectedCustomerId);
      let data = this.customerList.filter((val) => {
        if (val["custId"] == custId) return val;
      });
      this.selectedCustomerId = data[0];
    }
    this.cdRef.detectChanges();
  }

  epochToHHMMSS(epochTime: any) {
    return moment
      .tz(this.timeZone || "Asia/Kolkata")
      .startOf("hour")
      .format("YYYY-MM-DD HH:mm:ss");
  }

  statusColor(data) {
    switch (data) {
      case 1: {
        return "#548237";
        break;
      }
      case 0: {
        return "#f7c030";
        break;
      }
      case 2: {
        return "#eb5857";
        break;
      }
      case 3: {
        return "#7B542F";
        break;
      }
      case 4: {
        return "#b0b0b0";
        break;
      }
      default: {
        return "#b0b0b0";
        break;
      }
    }
  }

  redirctTO(data) {
    this.sharedService.setCheckedList({
      custID: this.customerId,
      deviceID: data.device_id,
      deviceName: data.deviceName,
      deviceType: data.deviceType,
    });
    this.sharedService.setShiftData({
      shift: data["Shift_List"],
    });
    let divdata = this.deviceList.filter((val) => {
      if (val["deviceName"] === data.deviceName) {
        return val;
      }
    });
 if(divdata[0]["oee"] === 'no_part'){

   var record: any = {
     custID: this.customerId,
     deviceID: data.device_id,
     deviceName: data.deviceName,
     deviceType: data.deviceType,
     configType: divdata[0]["oee"],
     department: divdata[0]["departmentName"],
   };

   sessionStorage.setItem("machineInfio", JSON.stringify(record));

   this.router.navigate(["/detailedMachine"]);
 }else{
     var record: any = {
     custID: this.customerId,
     deviceID: data.device_id,
     deviceName: data.deviceName,
     deviceType: data.deviceType,
     configType: divdata[0]["oee"],
     department: divdata[0]["departmentName"],
     partcountType:divdata[0]["partcountType"]
   };

   sessionStorage.setItem("machineInfio", JSON.stringify(record));

   this.router.navigate(["/detailedMachine"]);
 }
  }

  backbtn() {
    this.router.navigate(["/"]);
  }

  ngOnDestroy() {
    this.machine_List = [];
    if (this.apiInterval) {
      clearTimeout(this.apiInterval);
    }
    this.toastr.clear();
    this.abortController.abort();
    this.destroy$.next();
    this.destroy$.complete();
    this.cancelRequest = true;
  }

}
